import './assets/main.css'
import 'vue3-form-wizard/dist/style.css' 
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.js'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'

import 'vue-cal/dist/vuecal.css'
import '@vueup/vue-quill/dist/vue-quill.snow.css'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { defineRule } from 'vee-validate'

import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { MaskInput } from 'vue-3-mask'
library.add(fas, far)
dom.watch()

import App from './App.vue'
import router from './router'
import {
  BForm,
  BPopover,
  BButton,
  BFormRadioGroup,
  BFormGroup,
  BTooltip,
  BRow,
  BCol,
  BFormRow,
  BFormInput,
  BModal,
  BFormCheckbox,
  BFormCheckboxGroup,
  BFormInvalidFeedback,
  BFormSelect,
  BLink
} from 'bootstrap-vue-next'

defineRule('minMax', (value, [min, max]) => {
    // The field is empty so it should pass
    if (!value || !value.length) {
      return true;
    }
    const numericValue = Number(value);
    if (numericValue < min) {
      return `This field must be greater than ${min}`;
    }
    if (numericValue > max) {
      return `This field must be less than ${max}`;
    }
    return true;
  });
  defineRule('required', value => {
    if (!value) {
      return 'This field is required';
    }
    return true;
  });
  defineRule('email', value => {
    // Field is empty, should pass
    if (!value || !value.length) {
      return true;
    }
    // Check if email
    // eslint-disable-next-line no-useless-escape
    if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)) {
      return 'This field must be a valid email';
    }
    return true;
  });
  
  defineRule('minLength', (value, [limit]) => {
    // The field is empty so it should pass
    if (!value || !value.length) {
      return true;
    }
    if (value.length < limit) {
      return `This field must be at least ${limit} characters`;
    }
    return true;
});

const app = createApp(App).component('font-awesome-icon', FontAwesomeIcon)
app.use(createPinia())
app.use(router)

app.component('BForm', BForm)
app.component('BPopover', BPopover);
app.component('BButton', BButton)
app.component('BFormRadioGroup', BFormRadioGroup)
app.component('BFormGroup', BFormGroup)
app.component('BRow', BRow)
app.component('BCol', BCol)
app.component('BTooltip', BTooltip)
app.component('BFormRow', BFormRow)
app.component('BFormInput', BFormInput)
app.component('BFormCheckbox', BFormCheckbox)
app.component('BFormCheckboxGroup', BFormCheckboxGroup)
app.component('BFormInvalidFeedback', BFormInvalidFeedback)
app.component('BFormSelect', BFormSelect)
app.component('BLink', BLink)
app.component('BModal', BModal)
app.component('MaskInput', MaskInput);

app.mount('#app')